/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */

'use strict';

module.exports = function isObject(val) {
  return val != null && typeof val === 'object'
    && !Array.isArray(val);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/is-plain-object/~/isobject/index.js
 ** module id = 12
 ** module chunks = 0
 **/